import styled from "styled-components";
import { FC } from "react";

interface Props {
  pt?: string;
  pb?: string;
  background?: string;
  minus?: string;
  paddingBackground?: string;
}

export const Fullscreen: FC<React.PropsWithChildren<Props>> = ({
  pt,
  pb,
  background,
  minus,
  paddingBackground,
  children,
}) => (
  <FullscreenContainer pt={pt} pb={pb} minus={minus} background={paddingBackground}>
    <PositioningWrapper background={background}>{children}</PositioningWrapper>
  </FullscreenContainer>
);

const FullscreenContainer = styled.div<{
  pt?: string;
  pb?: string;
  background?: string;
  minus?: string;
}>`
  position: relative;
  overflow: hidden;

  @media only screen and (orientation: landscape) {
    width: 100vw;
    min-height: ${(p) => (p.minus ? `calc(100vh - ${p.minus})` : "100vh")};

    /* this seems to be the only way to make children of
     elements scaled by viewport take up the full height */
    display: flex;
    align-items: stretch;
  }

  ${(p) => (p.pt ? `padding-top: ${p.pt};` : "")}
  ${(p) => (p.pb ? `padding-bottom: ${p.pb};` : "")}
  ${(p) => (p.background ? `background: ${p.background};` : "")}
`;

const PositioningWrapper = styled.div<{ background?: string }>`
  ${(p) => (p.background ? `background: ${p.background};` : "")}
  // this is so that positioned children ignore any padded areas
  position: relative;
  display: flex;
  align-items: stretch;
`;
